import React, { useState } from "react";

import {
    Button,
} from 'react95';

const NextPrev = props => {
    const prev = props.currentIndex > 0 ;
    const next = props.currentIndex < props.items - 1 ;
    if (prev && next) {
        return (
            <div>
                <Button size='lg' style={{ minWidth: "90px" }} onClick={props.prevAction}>
                    prev
                </Button>
              
                <Button size='lg' style={{ minWidth: "90px" }} className="mx-2" onClick={props.nextAction}>
                    next
                </Button>
            </div>
        )  
    } else if (next) {
         return <Button size='lg' style={{ minWidth: "90px" }} className="mx-2" onClick={props.nextAction}>
            next
      </Button>
    } else if(prev) {
       return  <Button size='lg' style={{ minWidth: "90px" }} onClick={props.prevAction}>
            prev
      </Button>
    }
};

export default NextPrev;


